import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { menuToggler } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import ContactModal from './ContactModal';
import { colors } from '../styles';

const styles = css`
  position: fixed;
  top: 68px;
  right: 0;
  bottom: 0;
  width: calc(100% - 30px);
  padding: 20px 20px 20px 20px;
  overflow-y: scroll;
  z-index: 40;
  background-color: #FFFFFF;
  transform: translateX(400px);
  transition: transform 250ms cubic-bezier(0.165, 0.84, 0.44, 1);
  @media (min-width: 420px) {
    transform: translateX(600px);
  }
  @media (min-width: 620px) {
    transform: translateX(960px);
  }
  @media (min-width: 992px) {
    padding: 0;
    display: inline-block;
    right: 0;
    top: 0;
    left: auto;
    bottom: auto;
    overflow: visible;
    background-color: transparent;
    width: auto;
    transform: translateX(0);
  }
  &.HeaderMenu-active {
    transform: translateX(0);
  }
  .HeaderMenu_menuClose {
    display: none;
    position: absolute;
    right: 15px;
    top: 15px;
    width: 20px;
    height: 20px;
    padding: 0;
    box-sizing: content-box;
    background-image: url('/images/icon-close.svg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 20px 20px;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    @media (min-width: 992px) {
      display: none;
    }
  }
  .HeaderMenu_menu {
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: left;
    @media (min-width: 992px) {
      display: inline-block;
    }
  }
  .HeaderMenu_menuItem {
    list-style: none;
    border-bottom: 1px solid #CCCCCC;
    @media (min-width: 992px) {
      display: inline-block;
      margin: 0;
      vertical-align: top;
      border: 0;
      position: relative;
    }
  }
  .HeaderMenu_menuHeading {
    font-size: 18px;
    font-weight: 800;
    padding: 15px 0;
    background-image: url('/images/icon-triangle-green.svg');
    background-position: calc(100% - 15px) center;
    background-repeat: no-repeat;
    cursor: pointer;
    display: block;
    color: ${colors.color1Dark};
    @media (min-width: 992px) {
      font-weight: 400;
      font-size: 14px;
      cursor: default;
      position: relative;
      padding: 0 30px 0 15px;
      line-height: 100px;
      height: 100px;
      transition: all .3s ease;
      cursor: pointer;
      text-transform: uppercase;
      font-weight: 700;
      letter-spacing: 1px;
      &:hover, &:focus {
        outline: none;
        border: none;
      }
    }
  }
  .HeaderMenu_menuLink {
    font-size: 18px;
    font-weight: 800;
    padding: 15px 0;
    cursor: pointer;
    display: block;
    color: ${colors.color2};
    @media (min-width: 992px) {
      color: #FFFFFF;
      font-weight: 400;
      font-size: 14px;
      cursor: default;
      position: relative;
      padding: 0 20px;
      line-height: 70px;
      height: 70px;
      transition: all .3s ease;
      cursor: pointer;
      text-transform: uppercase;
      font-weight: 700;
      letter-spacing: 1px;
      background-color: rgba(0,0,0,1);
      &:hover, &:focus {
        outline: none;
        border: none;
      }
      &-contact {
        background-color: #c6cc27;
        color: #111111;
      }
    }
  }
  .HeaderMenu_subMenu {
    display: none;
    list-style: none;
    padding: 0 0 15px 0;
    margin: 0;
    position: relative;
    @media (min-width: 992px) {
      position: absolute;
      top: 100px;
      left: 0;
      width: auto;
      min-width: 300px;
      background-color: #FFFFFF;
      color: #FFFFFF;
      padding: 0 5px 5px 5px;
      font-size: 15px;
    }
  }
  .HeaderMenu_menuItem:last-child .HeaderMenu_subMenu {
    @media (min-width: 992px) {
      left: auto;
      right: 0;
    }
  }
  .HeaderMenu_subMenu-active {
    display: block;
  }
  .HeaderMenu_subMenuItem a {
    color: ${colors.color1Dark};
    padding: 12px 15px;
    display: block;
    transition: all .3s ease;
    background-color: #FFFFFF;
    font-weight: 700;
    &:hover {
      background-color: #F5F5F5;
    }
  }
`;

function HeaderMenu({ isActive, toggleMenu, builder }) {
  return (
    <div className={`${styles} ${isActive ? 'HeaderMenu-active' : ''}`} >
      <button className="HeaderMenu_menuClose" onClick={toggleMenu} />
      <ul className="HeaderMenu_menu">
        <li className="HeaderMenu_menuItem">
          <Link className="HeaderMenu_menuLink" name="index">Home Page</Link>
        </li>
        <li className="HeaderMenu_menuItem">
          <Link className="HeaderMenu_menuLink" name="agenda">Agenda</Link>
        </li>
        <li className="HeaderMenu_menuItem">
          <Link className="HeaderMenu_menuLink" name="speakers">Speakers</Link>
        </li>
        {/* <li className="HeaderMenu_menuItem">
          <Link className="HeaderMenu_menuLink" name="index" hash="#venue">Venue</Link>
        </li> */}
        <li className="HeaderMenu_menuItem">
          <ContactModal builder={builder}>
            <div className="HeaderMenu_menuLink HeaderMenu_menuLink-contact" role="button" tabIndex="0" >Register Now!</div>
          </ContactModal>
        </li>
      </ul>
    </div>
  );
}

HeaderMenu.propTypes = {
  isActive: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  builder: PropTypes.object.isRequired,
};

export default withData(
  {
    builder: true,
  },
)(menuToggler(HeaderMenu));



// WEBPACK FOOTER //
// ./src/components/HeaderMenu.js